import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PropertySearchCardVM } from '../../../models/property-search-card.vm';

/**
 * Card unitaria de una propiedad en resultados de búsqueda.
 * 100% presentacional: recibe un {@link PropertySearchCardVM} y emite el
 * id al hacer click. No conoce services, router ni estado.
 */
@Component({
    selector: 'app-property-card',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './property-card.component.html',
    styleUrls: ['./property-card.component.scss'],
})
export class PropertyCardComponent {
    @Input() vm!: PropertySearchCardVM;
    @Output() select = new EventEmitter<number>();
}
